"use strict";
// (C) 2021-2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.canApplyDateFilter = exports.dispatchFilterContextChanged = void 0;
var tslib_1 = require("tslib");
var effects_1 = require("redux-saga/effects");
var filters_1 = require("../../events/filters");
var filterContextSelectors_1 = require("../../store/filterContext/filterContextSelectors");
var eventDispatcher_1 = require("../../store/_infra/eventDispatcher");
var dateFilterConfigSelectors_1 = require("../../store/dateFilterConfig/dateFilterConfigSelectors");
var dateFilterOptionMapping_1 = require("../../../_staging/dateFilterConfig/dateFilterOptionMapping");
function dispatchFilterContextChanged(ctx, cmd) {
    var filterContext;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(filterContextSelectors_1.selectFilterContextDefinition)];
            case 1:
                filterContext = _a.sent();
                return [4 /*yield*/, eventDispatcher_1.dispatchDashboardEvent(filters_1.filterContextChanged(ctx, filterContext, cmd.correlationId))];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
exports.dispatchFilterContextChanged = dispatchFilterContextChanged;
function canApplyDateFilter(dateFilter) {
    var effectiveDateFilterOptions, targetOption;
    var _a, _b, _c;
    return tslib_1.__generator(this, function (_d) {
        switch (_d.label) {
            case 0: return [4 /*yield*/, effects_1.select(dateFilterConfigSelectors_1.selectEffectiveDateFilterOptions)];
            case 1:
                effectiveDateFilterOptions = _d.sent();
                targetOption = dateFilterOptionMapping_1.findDateFilterOptionByValue(dateFilter, effectiveDateFilterOptions);
                if (!targetOption) {
                    if (dateFilter.dateFilter.type === "absolute") {
                        return [2 /*return*/, !!((_a = effectiveDateFilterOptions === null || effectiveDateFilterOptions === void 0 ? void 0 : effectiveDateFilterOptions.absoluteForm) === null || _a === void 0 ? void 0 : _a.visible)];
                    }
                    else if (dateFilter.dateFilter.type === "relative") {
                        if (dateFilter.dateFilter.granularity === "GDC.time.date" &&
                            dateFilter.dateFilter.from === undefined &&
                            dateFilter.dateFilter.to === undefined) {
                            return [2 /*return*/, !!((_b = effectiveDateFilterOptions === null || effectiveDateFilterOptions === void 0 ? void 0 : effectiveDateFilterOptions.allTime) === null || _b === void 0 ? void 0 : _b.visible)];
                        }
                        return [2 /*return*/, !!((_c = effectiveDateFilterOptions === null || effectiveDateFilterOptions === void 0 ? void 0 : effectiveDateFilterOptions.relativeForm) === null || _c === void 0 ? void 0 : _c.visible)];
                    }
                }
                return [2 /*return*/, !!targetOption];
        }
    });
}
exports.canApplyDateFilter = canApplyDateFilter;
//# sourceMappingURL=common.js.map